module.exports = __webpack_public_path__ + "img/glogo224.ead06c32.png";